module.exports = __webpack_public_path__ + "media/components/map/marker-images/pause-icon-e7c0d8bd84acfe7f35be4eb18cfe752e.png";